import * as R from "remeda";
import { z } from "zod";

export const CreditGroupTypeSchema = z.enum([
  "MEMBERSHIP",
  "PACK",
  "STORE_GRANT",
]);

export const CreditGroupType = CreditGroupTypeSchema.enum;

export const CreditGroupStatusSchema = z.enum([
  "CANCELLED",
  "FROZEN",
  "ACTIVE_IN_FUTURE",
  "DELINQUENT",
  "ACTIVE",
  "INVALID",
]);

export const CreditGroupStatus = CreditGroupStatusSchema.enum;

export const PaymentPlanSchema = z.object({
  payment_plan_membership_id: z.number().nullable().optional(),
  payment_plan_purchasable_item_id: z.number().nullable().optional(),
  payment_plan_name: z.string().nullable().optional(),
  payment_plan_billing_cycles_required: z.number().optional(),
  payment_plan_billing_cycles_required_total: z.number().optional(),
  loading_dose_purchasable_item_id: z.number().nullable().optional(),
  loading_dose_name: z.string().nullable().optional(),
  loading_dose_credits_remaining: z.number().optional(),
  loading_dose_credit_type: z.number().nullable().optional(),
  loading_dose_expiration_datetime: z.coerce.date().nullable().optional(),
});

export type PaymentPlan = z.infer<typeof PaymentPlanSchema>;

export const PlanDosageSchema = z.object({
  remaining_dosage: z.number(),
  bookable_services: z.array(z.string()),
});

export type PlanDosage = z.infer<typeof PlanDosageSchema>;

const BaseCreditGroupSchema = z.object({
  guid: z.string(),
  type: z.string(),
  status: CreditGroupStatusSchema,
  credits_remaining: z.number(),
  group_service_name: z.string(),
  group_service_id: z.number(),
  next_expiration_datetime: z.string().nullable(),
  is_primary_membership: z.boolean(),
  store_description: z.string(),
  store_code: z.string(),
  next_expiration_credits: z.number(),
  associated_service_id: z.number().nullable(),
  are_all_credits_frozen: z.boolean(),
  freeze_expiration_datetime: z.string().nullable(),
  store_tz: z.string(),
  is_universal: z.boolean(),
});

export const NadNrCreditTypeSchema = z.union([
  z.literal(108),
  z.literal(123),
  z.literal(124),
]);

export const nadNrCreditTypes = R.pipe(
  NadNrCreditTypeSchema.options,
  R.map((item) => item.value as number),
);

export const NadNrCreditGroupSchema = z
  .object({
    credit_type: NadNrCreditTypeSchema,
    associated_payment_plan: PaymentPlanSchema.nullable(),
    // TODO: remove optional when api ready
    plan_dosage_information: PlanDosageSchema.nullable().optional(),
  })
  .extend(BaseCreditGroupSchema.shape);

export type NadNrCreditGroup = z.infer<typeof NadNrCreditGroupSchema>;

export const CreditGroupSchema = z.union([
  NadNrCreditGroupSchema,
  z
    .object({
      credit_type: z.union([z.literal(1), z.literal(2)]),
    })
    .extend(BaseCreditGroupSchema.shape),
]);

export type CreditGroup = z.infer<typeof CreditGroupSchema>;
